export const MINIMUM_NAME_LENGTH_ERROR =
  'Name should be atleast 3 characters long';
export const PHONE_NUMBER_ERROR = 'Phone number should have exactly 10 digits';
export const PROFESSIONAL_EMAIL_ERROR =
  'Please enter a valid professional email Id';
export const EMAIL_AT_ERROR = "Email should have only one '@'";
export const EMAIL_DOMAIN_ERROR = 'Please check the email domain.';
export const REQUIRED_FIELD_ERROR = 'Field is required';
export const INTERESTED_PRODUCT = 'Please select the interest product.';

export const VALIDATOR_SUCCESS = { validity: true, error: '' };
export const VALIDATOR_FAILURE = { validity: false };
